import { MessageCircle, Mail, MapPin, Phone } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const WHATSAPP = process.env.REACT_APP_WHATSAPP_NUMBER || "919003140803";

const Contact = () => (
  <section id="contact" data-testid="contact-section" className="border-t border-white/10 py-24 lg:py-32">
    <div className="mx-auto max-w-[900px] px-6 lg:px-12">
      <Reveal>
        <p className="mb-4 text-xs font-medium uppercase tracking-[0.25em] text-[#7ED321]">Get in Touch</p>
        <h2 className="font-display text-4xl uppercase leading-[0.95] text-white sm:text-5xl lg:text-6xl">
          We'd love to <span className="text-outline">hear from you</span>
        </h2>
        <p className="mt-6 max-w-md text-sm leading-relaxed text-[#A6A66A] md:text-base">
          Questions about your order or our bars? We'd love to hear from you — message us
          anytime and we'll respond within 24 hours.
        </p>

        <div className="mt-10 space-y-5">
          <a
            href="mailto:info@zentrafoods.in"
            data-testid="contact-email-link"
            className="flex w-fit items-center gap-4 text-sm text-white/70 transition-colors duration-300 hover:text-[#7ED321]"
          >
            <Mail className="h-4 w-4 shrink-0 text-[#7ED321]" />
            info@zentrafoods.in
          </a>
          <div className="flex items-center gap-4 text-sm text-white/70">
            <Phone className="h-4 w-4 shrink-0 text-[#7ED321]" />
            <span>
              <a href="tel:+919003140803" data-testid="contact-phone-link" className="transition-colors duration-300 hover:text-[#7ED321]">+91 90031 40803</a>
              {" · "}
              <a href="tel:04227960085" data-testid="contact-landline-link" className="transition-colors duration-300 hover:text-[#7ED321]">0422 7960085</a>
            </span>
          </div>
          <div className="flex items-center gap-4 text-sm text-white/70">
            <MapPin className="h-4 w-4 shrink-0 text-[#7ED321]" />
            Mountain Fresh Farms LLP, Rajaram Industrial Estate, Vellandipalayam, Coimbatore – 641025
          </div>
          <div className="flex items-start gap-4 text-sm text-white/70">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#7ED321]" />
            <span>
              <span className="text-white/40">Regd. Off: </span>
              96, 3rd Cross Street, Super Garden Avenue, Vadavalli, Coimbatore – 641041
            </span>
          </div>
        </div>

        <div className="mt-10 flex flex-wrap gap-4">
          <a
            href={`https://wa.me/${WHATSAPP}?text=${encodeURIComponent("Hi Zentra! I have a question about your bars.")}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-whatsapp-button"
            className="inline-flex items-center gap-2 rounded-sm bg-[#25D366] px-8 py-4 text-sm font-bold uppercase tracking-[0.15em] text-white transition-colors duration-300 hover:bg-[#2be374]"
          >
            <MessageCircle className="h-4 w-4" />
            Chat on WhatsApp
          </a>
          <a
            href={`tel:+${WHATSAPP}`}
            data-testid="contact-call-button"
            className="inline-flex items-center gap-2 rounded-sm border border-white/20 px-8 py-4 text-sm font-bold uppercase tracking-[0.15em] text-white transition-colors duration-300 hover:border-[#7ED321] hover:text-[#7ED321]"
          >
            <Phone className="h-4 w-4" />
            Call Us
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Contact;
